<template>
  <div class="zhu-zi-song">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全景视频" name="first">
        <!-- <div v-if="!isShow"> -->
        <div v-show="result.data.videoUrl">
          <h3 style="text-align: center;" v-text="result.data.artiName"></h3>
          <div style="cursor:pointer;width:100%;position:absloute;">
            <div style="border: 1px solid #888;width:100%;height:450px;position:relative">
              <div :id="id" class="pan"></div>
            </div>
          </div>
        </div>
        <!-- </div> -->
        <div v-show="result.data.videoUrl==null">
          <h3 style="text-align: center;" v-text="result.data.artiName"></h3>
          <img
            style="border: 0; height: 450px; width: 100%;cursor:pointer"
            src="../../assets/portal/zwsj2.png"
          />
        </div>
      </el-tab-pane>
      <el-tab-pane label="全景浏览" name="secondfirst">
        <div v-if="isShow">
          <div v-show="result.data.fileUrl">
            <h3 style="text-align: center;" v-text="result.data.artiName"></h3>
            <iframe
              :src="result.data.fileUrl"
              style="border: 0; height: 450px; width: 100%;cursor:pointer"
            ></iframe>
          </div>
        </div>
        <div v-show="result.data.fileUrl==null">
          <h3 style="text-align: center;" v-text="result.data.artiName"></h3>
          <img
            style="border: 0; height: 450px; width: 100%;cursor:pointer"
            src="../../assets/portal/zwsj2.png"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
    <div>
      <p style="font-weight:bold;font-size:1.8rem;">遗存介绍:</p>
      <content v-html="result.data.content"></content>
    </div>
  </div>
</template>
<script>
require("../../styles/portal/culture.scss");
export default {
  data() {
    return {
      activeName: "first",
      Url: null,
      id: "vr",
      tbConfig: {
        videoQuality: 1,
        videoList: []
      },
      routeType: "arti",
      videoList: [],
      isShow: false,
      isShowAll: true,
      playerObj: null,
      params: {
        container: null,
        name: "SceneViewer",
        isGyro: true, //默认开启陀螺仪功能  移动端支持陀螺仪设备有效
        isMouseWheel: false, //禁止滚轮缩放
        scenesArr: [],
        initOverCallBack: function() {
          this.isShowAll = false;
          /*将播放器对象赋值给playerObj*/
          window.playerObj = this;
        },
        errorCallBack: function(e) {
          console.log("错误状态：" + e);
        },
        sceneEventClickCallBack: function(e) {
          if (this.isShowAll) {
            this.isShowAll = false;
          } else {
            this.isShowAll = true;
          }
        },
        fsCallBack: function(status, playObj) {
          alert("浏览器不支持全屏！");
        }
      }
    };
  },
  props: {
    routeWatch: {
      type: Boolean,
      default: true
    },
    result: {
      type: Object
    }
  },
  mounted() {},
  components: {
    //BsDetail: () => import("../../components/bs-detail")
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      if (this.activeName == "first") {
        this.isShow = false;
      } else {
        this.isShow = true;
        // if (this.playerObj != null && this.playerObj.api_setVideoPause) {
          window.playerObj.api_setVideoPause();
        // }
      }
    }
  },
  computed: {
    currentModule() {
      return `${this.$route.params._module}_${this.$route.params._field}`;
    },
    inint() {
      this.params.container = document.getElementById(this.id);
      this.params.scenesArr = [
        {
          sceneId: "v1",
          sceneName: "赛车",
          // sceneFilePath:
          //  "http://whlyw.net:8073/Attachment/PuTian/ruiyunshan/1024/index.m3u8",
          sceneFilePath: this.result.data.videoUrl,
          sceneType: "Video"
        }
      ];
      this.videoList.push({
        Text: "超高清",
        Quality: 1,
        Resolution: "2048x1024",
        // M3U8:
        //   "http://whlyw.net:8073/Attachment/PuTian/ruiyunshan/1024/index.m3u8",
        M3U8: this.result.data.videoUrl,
        RTMP: null
      });
      initLoad(this.params, function(playMode) {}, this.tbConfig);
    }
  },
  created() {
    //this.$menuFn.setTitle("portal-from-detail");
    this.id = "vr" + Math.ceil(Math.random() * 100000000);
  },
  watch: {
    $route: function(to, from) {
      // debugger
      if (
        from.name === "portal-arti-detail-whycpage" &&
        to.name === "portal-arti-page"
      ) {
        document.getElementById(this.id).innerHTML = "";
        let idN = "vr" + Math.ceil(Math.random() * 100000000);
        this.videoList = [];
        this.params.container = null;
        this.params.scenesArr = [];
      }
    },
    result: function(to, from) {
      //debugger;
      if (!to.data || !to.data.videoUrl) return;
      this.params.container = document.getElementById(this.id);
      this.params.scenesArr = [
        {
          sceneId: "v1",
          sceneName: "赛车",
          sceneFilePath: this.result.data.videoUrl,
          sceneType: "Video"
        }
      ];
      this.videoList.push({
        Text: "超高清",
        Quality: 1,
        Resolution: "2048x1024",
        M3U8: this.result.data.videoUrl,

        RTMP: null
      });
      initLoad(this.params, function(playMode) {}, this.tbConfig);
    }
  }
};
</script>
<style type="text/scss" lang="scss">
p img {
  width: 100%;
}
#pan {
  // position: absolute;
  width: 100%;
  height: 400px;
  cursor: pointer;
}
.pan {
  width: 100%;
  height: 400px;
  cursor: pointer;
}
</style>